import { AxiosPromise } from 'axios';

import { Axios, AxiosService } from '@/services/Axios';
import { ReportResponse } from '@/store/reducers/reports/types';
import { queryParamsSerializer } from '@/utils/query-params-serializer';

import { ACTIVITIES_PER_PAGE } from '../Activity/constants';
import { Params } from '../Activity/types';

export class ReportControllerClass {
  constructor(private APIService: AxiosService) {}

  fetchReportFile = async (): Promise<Blob> => {
    const downloadReportURL = `projects/export`;
    const reportsResponse = await this.APIService.post<Blob>(downloadReportURL);

    return new Blob(['\ufeff', reportsResponse.data]);
  };

  fetchReport = (page: number | null): AxiosPromise<ReportResponse> => {
    const params: Params = {
      pageNumber: page || 1,
      pageSize: ACTIVITIES_PER_PAGE,
    };

    return this.APIService.get(`/projects/report?${queryParamsSerializer(params)}`);
  };
}

export const ReportController = new ReportControllerClass(Axios);
